import axiosClient from '../configs/axios';


class RmIssuedService {
    // Get list 
    async getRmIssuedList(params) {
        try {
            const login_details = sessionStorage.getItem("loginUser");
        const userD = JSON.parse(login_details);
        const userInfo = userD?.result?.userInfo;
        

        const unit_id = userInfo?.depot_id || userInfo?.plant_id ;
            const response = await axiosClient.get(
                `/rm_issue/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}&unit_id=${unit_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addRmIssued(data) {
        try {
            const response = await axiosClient.post('/rm_issue/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteRmIssued(data) {
        try {
            const response = await axiosClient.put(`/rm_issue/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new RmIssuedService(); 